<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card :title="$t('spots.classificationSpots')">
        <template slot="actions">
          <va-button class="backButton" outline @click.prevent="toLocation" icon="fa fa-chevron-left">{{location.name}}</va-button>
          <va-button class="backButton" outline @click.prevent="toQrs" icon="fa fa-chevron-right">{{ $t('spots.qrCodesView') }}</va-button>
          <va-button @click.prevent="editModal" icon="fa fa-edit"/>
          <va-button @click.prevent="addModal" icon="fa fa-plus"/>
        </template>
      </va-card>
    </div>
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card stripe="info">
        <div class="row">
          <div
            class="flex xs12 sm6 md6 lg3"
            v-for="(info, idx) in spots"
            :key="info.eventSpotId"
          >
            <va-card :color="spotCardColor(info.isOccupied)">
              <p class="display-2 mb-0" style="color: white;">
                <span class="icon_actions">
                  <va-button-group color="info" class="display-1">
                    <va-button flat small color="#ffffff" @click="printModal(info.codeIdentifier)" icon-right="fa fa-print"></va-button>
                    <!--                    <va-button flat small color="#ffffff" @click="refreshCode(info.eventSpotId)" icon-right="fa fa-refresh"></va-button>-->
                    <va-button flat small color="#ffffff" @click="showPromptModal(info.eventSpotId, idx)" icon-right="fa fa-trash"></va-button>
                  </va-button-group>
                </span>
                <span>{{ classification.spotIdentifier + ' ' + info.spotIdentifier }}</span>
                <span class="event_span">{{info.isOccupied ? $t('spots.occupied') : $t('spots.available')}}</span>
                <span class="static_span">{{info.isStatic ? $t('spots.locked') : $t('spots.unlocked')}}</span>
              </p>
            </va-card>
          </div>
        </div>
      </va-card>
    </div>
    <va-modal
      v-model="openEditModal"
      :title="$t('spots.editSpot')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <form>
        <div class="row">
          <va-input
            v-model="editSpot.name"
            type="text"
            :label="$t('spots.inputSpot')"
            :placeholder="$t('spots.placeholderSpot')"
            :error="!!nameErrors.length"
            :error-messages="nameErrors"
            class="flex xs12"
          />

          <va-input
            v-model="editSpot.spotIdentifier"
            type="text"
            :label="$t('spots.inputIdentifier')"
            :placeholder="$t('spots.placeholderIdentifier')"
            :error="!!classificationIdentifierError.length"
            :error-messages="classificationIdentifierError"
            class="flex xs12"
          />
        </div>
        <div class="d-flex justify--center mt-3">
          <va-button color="gray" @click.prevent="closeModal()" class="my-0 ">{{ $t('spots.btnClose') }}</va-button>
          <va-button type="submit" :disabled="isLoading" @click.prevent="onEditSubmit()" class="my-0">{{ $t('spots.btnUpdate') }}</va-button>
        </div>
      </form>
    </va-modal>
    <va-modal
      v-model="openAddModal"
      :title="$t('spots.addSpot')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <form>
        <div class="row">
          <va-input
            v-model="addSpot.spotIdentifier"
            type="text"
            :label="$t('spots.inputSpotIdentifier')"
            :placeholder="$t('spots.placeholderSpotIdentifier')"
            :error="!!spotIdentifierError.length"
            :error-messages="spotIdentifierError"
            class="flex xs12"
          />

          <fieldset>
            <va-checkbox
              :label="$t('spots.checkboxSpot')"
              v-model="addSpot.isStatic"
            />
          </fieldset>
        </div>
        <div class="d-flex justify--center mt-3">
          <va-button color="gray" @click.prevent="closeModal()" class="my-0 ">{{ $t('spots.btnClose') }}</va-button>
          <va-button type="submit" :disabled="isLoading" @click.prevent="onAddSubmit()" class="my-0">{{ $t('spots.btnCreate') }}</va-button>
        </div>
      </form>
    </va-modal>
    <va-modal
      v-model="openPrintModal"
      :title="$t('spots.printSpot')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <va-button outline color="gray" icon="fa fa-print" @click.prevent="printCode"> {{ $t('spots.btnPrint') }}</va-button>
      <div id="printCode">
        <qrcode-vue v-if="codeToPrint !== null" render-as="svg" :value="codeToPrint" size="300" level="H"></qrcode-vue>
        {{ $t('spots.parkingSlot') }}
      </div>
      <div class="d-flex justify--center mt-3">
        <va-button color="gray" @click.prevent="closeModal()" class="my-0 ">{{ $t('spots.btnClose') }}</va-button>
      </div>
    </va-modal>
    <va-modal
      v-model="showRemoveModal"
      size="small"
      :title="$t('spots.deleteSpot')"
      :message="$t('spots.deleteMessage')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <div class="d-flex justify--center mt-3">
        <va-button color="gray" @click="showRemoveModal=false" class="my-0 ">{{ $t('spots.btnNo') }}</va-button>
        <va-button type="submit" @click="removeSpot(eventSpotIdInPrompt, indexInPrompt)" class="my-0">{{ $t('spots.btnYes') }}</va-button>
      </div>
    </va-modal>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import QrcodeVue from 'qrcode.vue'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
export default {
  name: 'EventSpots',
  components: { SwappingSquaresSpinner, QrcodeVue },
  mixins: [errorHandlerMixin],
  data () {
    return {
      openEditModal: false,
      openAddModal: false,
      openPrintModal: false,
      nameErrors: [],
      spotIdentifierError: [],
      classificationIdentifierError: [],
      isLoading: false,
      codeToPrint: null,
      location: {
        name: '',
        eventId: '',
      },
      editSpot: {
        name: '',
        spotIdentifier: '',
        spotClassificationId: '',
      },
      addSpot: {
        spotIdentifier: '',
        isStatic: false,
      },
      classificationId: undefined,
      classification: {},
      spots: [],
      showRemoveModal: false,
      indexInPrompt: null,
      eventSpotIdInPrompt: null,
    }
  },
  methods: {
    printCode () {
      this.$htmlToPaper('printCode')
    },
    editModal () {
      this.openEditModal = true
    },
    addModal () {
      this.openAddModal = true
    },
    async printModal (spotCodeIdentifier) {
      await this.spotQrCode(spotCodeIdentifier)
      this.openPrintModal = true
    },
    closeModal () {
      this.openEditModal = false
      this.openAddModal = false
      this.openPrintModal = false
      this.codeToPrint = null
    },
    showPromptModal (eventSpotId, index) {
      this.eventSpotIdInPrompt = eventSpotId
      this.indexInPrompt = index
      this.showRemoveModal = true
      console.log('eventSpotId ' + this.eventSpotIdInPrompt)
      console.log('index ' + this.indexInPrompt)
    },
    toLocation () {
      this.$router.push({
        name: 'location',
        params: { locationId: this.classification.events[0].eventId },
      })
    },
    async toQrs () {
      await this.$router.push({
        name: 'spots-raw',
        params: { classificationId: this.classificationId },
      })
    },
    async spotQrCode (spotCodeIdentifier) {
      this.codeToPrint = 'https://' + this.$store.getters.namespace + '.valet.live/=spot/code/' + spotCodeIdentifier
    },
    onEditSubmit () {
      this.classificationIdentifierError = this.editSpot.spotIdentifier ? [] : [this.$t('spots.requiredIdentifier')]
      this.nameErrors = this.editSpot.name ? [] : ['Name is required']
      if (this.classificationIdentifierError.length || this.nameErrors.length) {
        return
      }
      this.isLoading = true
      this.$store.dispatch('updateClassification', {
        locationId: this.location.eventId,
        spotClassificationId: this.classificationId,
        name: this.editSpot.name,
        spotIdentifier: this.editSpot.spotIdentifier,
      }).then(() => { this.isLoading = false }).catch(err => this.errorHandler(err.response))
    },
    onAddSubmit () {
      this.spotIdentifierError = this.addSpot.spotIdentifier ? [] : [this.$t('spots.requiredIdentifier')]
      if (this.spotIdentifierError.length) {
        return
      }

      this.$store.dispatch('createSpot', {
        spotClassificationId: this.classificationId,
        spotIdentifier: this.addSpot.spotIdentifier,
        isStatic: this.addSpot.isStatic,
      }).then((resp) => this.addNewSpot(resp.data.message)).catch(err => this.errorHandler(err.response))
    },
    async addNewSpot (spot) {
      this.spots.splice(this.spots.length, -1, ...spot)
    },
    removeSpot (eventSpotId, idx) {
      this.$store.dispatch('deleteSpot', eventSpotId)
        .then(() => {
          this.removeThatSpot(idx)
          this.showRemoveModal = false
        })
        .catch(error => {
          this.errorHandler(error.response)
          this.showRemoveModal = false
        })
    },
    removeThatSpot (idx) {
      this.spots.splice(idx, 1)
    },
    refreshCode (eventSpotId) {
      this.$store.dispatch('refreshSpotCode', eventSpotId)
        .then((resp) => this.refreshThatCode(resp.data.message, eventSpotId))
        .catch(err => this.errorHandler(err.response))
    },
    async refreshThatCode (code, eventSpotId) {
      this.spots.filter(item => {
        if (item.eventSpotId === eventSpotId) {
          item.codeIdentifier = code
        }
      })
    },
    async initSpots (spots) {
      this.spots.splice(0, this.spots.length, ...spots)
      this.$store.commit('setLoading', false)
    },
    async initClassification (classification) {
      this.classification = classification
      this.location.name = this.classification.events[0].name
      this.location.eventId = this.classification.events[0].eventId
      this.editSpot.name = this.classification.name
      this.editSpot.spotIdentifier = this.classification.spotIdentifier
      this.editSpot.spotClassificationId = this.classification.spotClassificationId
    },
    async errorOnClassification () {
      this.toDashboard()
    },
    spotCardColor (isOccupied) {
      if (isOccupied) {
        return 'gray'
      }
      return 'success'
    },
    toDashboard () {
      this.$router.push({
        name: 'dashboard',
      })
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.classificationId = Number.parseInt(this.$route.params.classificationId)
    if (!this.classificationId) {
      this.toDashboard()
    }

    this.$store.dispatch('getClassificationByClassificationId', this.classificationId)
      .then((resp) => this.initClassification(resp.data.message))
      .catch(() => this.errorOnClassification())
      .then(() => this.$store.dispatch('getSpotsByClassification', this.classificationId))
      .then((resp) => {
        return this.initSpots(resp.data.message)
      }).catch(error => this.errorHandler(error.response))
  },
}
</script>

<style scoped>
  .backButton {
    line-height: normal !important;
    font-size: 11px;
  }

  .event_span {
    font-size: 10px;
    float: right;
    background: rgba(121, 121, 121, 0.5);
    padding: 5px;
    border-radius: 3px;
  }

  .static_span {
    font-size: 10px;
    float: right;
    background: rgba(121, 121, 121, 0.5);
    padding: 5px;
    border-radius: 3px;
    margin-right: 5px;
  }

  .icon_actions {
    float: right;
    background: rgba(121, 121, 121, 0.5);
    padding: 1px;
    margin-left: 5px;
    border-radius: 15px;
  }

  .icon_actions .va-button-group {
    margin: 0;
  }
</style>
